import { Injectable } from '@angular/core';
import { createEffect, Actions } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { of } from 'rxjs';
import * as fromServicesDue from './services-due.actions';
import { ServicesDueState } from './services-due.interfaces';
import { ApiService } from '@quorum/api';
import { LastWorkOrderForVehicleQueryParameters } from '@quorum/models/xs-query';
// eslint-disable-next-line max-len
import { VehicleMaintenanceScheduleServiceDue } from '@quorum/models/xs-resource';
import { from } from 'rxjs';
import { fromWorkOrders } from '@quorum/xsr-fixed-operations/state';
import { mergeAll, flatMap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
@Injectable()
export class ServicesDueEffects {
  
  getServicesDueFromServer = createEffect(() => this.dataPersistence.fetch(fromServicesDue.GET_SERVICES_DUE_FROM_SERVER, {
    run: (action: fromServicesDue.GetServicesDueFromServer, state: ServicesDueState) => {
      return this.apiService
        .get<VehicleMaintenanceScheduleServiceDue[]>(
          `v/1/vehicles/vehicles/${action.payload.vehicleId}/vehicle-maintenance-schedule-service-dues`
        )
        .pipe(
          flatMap(servicesDue => {
            let actions: Action[] = [];
            let serviceGroups: string = '';
            servicesDue.forEach((service: any) => {
              serviceGroups += service.serviceGroupId + ',';
            });
            if (serviceGroups.length > 0) {
              actions.push(
                new fromServicesDue.GetRoHistoryForServicesDueFromServer({
                  queryParams: new LastWorkOrderForVehicleQueryParameters({
                    serviceGroupId: serviceGroups.replace(/,\s*$/, '')
                  }),
                  vehicleId: action.payload.vehicleId
                })
              );
            }

            actions.push(
              new fromServicesDue.GetServicesDueFromServerSuccess({
                servicesDue: servicesDue
              })
            );
            return of(actions).pipe(mergeAll());
          })
        );
    },
    onError: (action: fromServicesDue.GetServicesDueFromServer, error) => {
      console.error('Error', error);
      return new fromServicesDue.GetServicesDueFromServerFailure({
        error: 'The services due for this vehicle could not be loaded.'
      });
    }
  }));

  
  getRoHistoryForServicesDueFromServer = createEffect(() => this.dataPersistence.fetch(
    fromServicesDue.GET_RO_HISTORY_FOR_SERVICES_DUE_FROM_SERVER,
    {
      run: (action: fromServicesDue.GetRoHistoryForServicesDueFromServer, state: any) => {
        return this.apiService
          .get<any[]>(`v/1/vehicles/vehicles/${action.payload.vehicleId}/latestWorkOrder`, {
            params: action.payload.queryParams
          })
          .pipe(
            flatMap(roHistory => {
              roHistory = Array.isArray(roHistory) ? roHistory : [];
              let temp = roHistory
                .filter((history: any) => history.workOrderId != null)
                .map((wo: any) => {
                  return wo.workOrderId;
                });
              if (temp.length > 0) {
                return from([
                  new fromServicesDue.GetRoHistoryForServicesDueFromServerSuccess({
                    roHistory: roHistory.filter((history: any) => history.workOrderId != null)
                  }),
                  new fromWorkOrders.GetWorkOrdersFromServer({ id: temp.join(',') })
                ]);
              } else {
                return from([
                  new fromServicesDue.GetRoHistoryForServicesDueFromServerSuccess({
                    roHistory: roHistory.filter((history: any) => history.workOrderId != null)
                  })
                ]);
              }
            })
          );
      },
      onError: (action: fromServicesDue.GetRoHistoryForServicesDueFromServer, error) => {
        console.error('Error', error);
        return new fromServicesDue.GetRoHistoryForServicesDueFromServerFailure({
          error: 'The service history for this vehicle could not be loaded.'
        });
      }
    }
  ));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<ServicesDueState>,
    private apiService: ApiService
  ) {}
}
